module.exports = __webpack_public_path__ + "static/media/chero.3428b839.png";